import React from "react";
import { Link } from "react-router-dom";
import {
  Users,
  UtensilsCrossed,
  Pill,
  Home as HomeIcon,
  Car,
  HandHeart,
  ArrowUpRight
} from "lucide-react";

const iconMap = {
  Users,
  UtensilsCrossed,
  Pill,
  Home: HomeIcon,
  Car,
  HandHeart
};

const ServiceCard = ({ service, index = 0, variant = "default" }) => {
  const Icon = iconMap[service.icon] || Users;

  return (
    <Link
      to={`/services#${service.id}`}
      data-testid={`service-card-${service.id}`}
      className="group relative bg-white rounded-3xl border border-stone-200/70 p-8 hover:border-amber-700/40 hover:shadow-lg transition-all duration-500 overflow-hidden block"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      {/* Decorative corner */}
      <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-amber-50 to-transparent rounded-bl-full opacity-60 group-hover:opacity-100 transition-opacity" />

      <div className="relative">
        <div className="w-14 h-14 rounded-2xl bg-stone-100 group-hover:bg-amber-700 flex items-center justify-center mb-6 transition-colors duration-500">
          <Icon className="w-7 h-7 text-amber-700 group-hover:text-white transition-colors duration-500" strokeWidth={1.5} />
        </div>

        <h3 className="font-serif text-2xl text-slate-900 mb-3 leading-tight">
          {service.title}
        </h3>
        <p className="text-slate-600 text-base leading-relaxed mb-6">
          {service.shortDescription}
        </p>

        <div className="flex items-center gap-2 text-amber-700 text-sm font-semibold tracking-wide">
          Learn More
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
